import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import '@wapharma/design-system/tokens.css';
import './styles/tailwind.css';
import './styles/breakpoints.css';
import './styles/a11y.css';
import './fonts';
import './fonts-display';
import '@wapharma/design-system/scrollbar.css';
import '@wapharma/design-system/scroll-fade.css';
import '@wapharma/design-system/fluid/scroll-area.css';
import { App } from './App';
import { initAdminSentry } from './lib/sentry';
import { AppErrorBoundary } from './components/AppErrorBoundary';

initAdminSentry();

/** Custom outlet scrollport — disable document scroll memory before first paint. */
if (typeof history !== 'undefined' && 'scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

function Root() {
  return (
    <MotionConfig reducedMotion="user">
      <AppErrorBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AppErrorBoundary>
    </MotionConfig>
  );
}

const app = <Root />;

/** StrictMode double-mounts huge pages (Catalog) and wedges dev tab on nav. */
ReactDOM.createRoot(document.getElementById('root')!).render(
  import.meta.env.PROD ? <StrictMode>{app}</StrictMode> : app,
);
